<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑菜单的按钮</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <div style="padding: 0px 0px 20px 20px;">当前菜单：{{menuName}}</div>


                <el-row>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonName1" placeholder="按钮名称" ></el-input>
                    </el-col>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonManualCode1" placeholder="按钮Code"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonName2" placeholder="按钮名称" ></el-input>
                    </el-col>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonManualCode2" placeholder="按钮Code"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonName3" placeholder="按钮名称" ></el-input>
                    </el-col>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonManualCode3" placeholder="按钮Code"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonName4" placeholder="按钮名称" ></el-input>
                    </el-col>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonManualCode4" placeholder="按钮Code"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonName5" placeholder="按钮名称" ></el-input>
                    </el-col>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonManualCode5" placeholder="按钮Code"></el-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonName6" placeholder="按钮名称" ></el-input>
                    </el-col>
                    <el-col :span="8" class="item">
                        <el-input v-model="buttonManualCode6" placeholder="按钮Code"></el-input>
                    </el-col>
                </el-row>



            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="edit">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import {newGuid} from "@/utils/guid";

    export default {
        name: 'EditButton',
        props: ["listMenuDTO"],
        data() {
            return {

                loading: false,

                menuCode:'',
                menuName:'',
                listMenuButton:[],


                buttonName1:'',
                buttonManualCode1:'',
                buttonName2:'',
                buttonManualCode2:'',
                buttonName3:'',
                buttonManualCode3:'',
                buttonName4:'',
                buttonManualCode4:'',
                buttonName5:'',
                buttonManualCode5:'',
                buttonName6:'',
                buttonManualCode6:'',


            }
        },

        methods: {

            init(data) {

                this.menuCode = data.menuCode;
                this.menuName = data.name;
                this.listMenuButton = data.listMenuButton;


                this.buttonName1 = '';
                this.buttonManualCode1 = '';
                this.buttonName2 = '';
                this.buttonManualCode2 = '';
                this.buttonName3 = '';
                this.buttonManualCode3 = '';
                this.buttonName4 = '';
                this.buttonManualCode4 = '';
                this.buttonName5 = '';
                this.buttonManualCode5 = '';


                for(var i=0;i<this.listMenuButton.length;i++){
                    if(i == 0){
                        this.buttonName1 = this.listMenuButton[i].buttonName;
                        this.buttonManualCode1 = this.listMenuButton[i].buttonManualCode;
                    }
                    if(i == 1){
                        this.buttonName2 = this.listMenuButton[i].buttonName;
                        this.buttonManualCode2 = this.listMenuButton[i].buttonManualCode;
                    }
                    if(i == 2){
                        this.buttonName3 = this.listMenuButton[i].buttonName;
                        this.buttonManualCode3 = this.listMenuButton[i].buttonManualCode;
                    }
                    if(i == 3){
                        this.buttonName4 = this.listMenuButton[i].buttonName;
                        this.buttonManualCode4 = this.listMenuButton[i].buttonManualCode;
                    }
                    if(i == 4){
                        this.buttonName5 = this.listMenuButton[i].buttonName;
                        this.buttonManualCode5 = this.listMenuButton[i].buttonManualCode;
                    }
                    if(i == 5){
                        this.buttonName6 = this.listMenuButton[i].buttonName;
                        this.buttonManualCode6 = this.listMenuButton[i].buttonManualCode;
                    }
                }



            },

            closeSelf() {
                this.$emit("closeEditButton");
            },

            edit(){

                var arr = [];
                if(this.buttonName1 != '' && this.buttonMenualCode1 != ''){
                    if(this.listMenuButton[0]!=null){
                        arr.push({menuButtonCode:this.listMenuButton[0].menuButtonCode,buttonName:this.buttonName1,buttonManualCode:this.buttonManualCode1});
                    }else{
                        arr.push({menuButtonCode:newGuid(),buttonName:this.buttonName1,buttonManualCode:this.buttonManualCode1});
                    }
                }
                if(this.buttonName2 != '' && this.buttonMenualCode2 != ''){
                    if(this.listMenuButton[1]!=null){
                        arr.push({menuButtonCode:this.listMenuButton[1].menuButtonCode,buttonName:this.buttonName2,buttonManualCode:this.buttonManualCode2});
                    }else{
                        arr.push({menuButtonCode:newGuid(),buttonName:this.buttonName2,buttonManualCode:this.buttonManualCode2});
                    }
                }
                if(this.buttonName3 != '' && this.buttonMenualCode3 != ''){
                    if(this.listMenuButton[2]!=null){
                        arr.push({menuButtonCode:this.listMenuButton[2].menuButtonCode,buttonName:this.buttonName3,buttonManualCode:this.buttonManualCode3});
                    }else{
                        arr.push({menuButtonCode:newGuid(),buttonName:this.buttonName3,buttonManualCode:this.buttonManualCode3});
                    }
                }
                if(this.buttonName4 != '' && this.buttonMenualCode4 != ''){
                    if(this.listMenuButton[3]!=null){
                        arr.push({menuButtonCode:this.listMenuButton[3].menuButtonCode,buttonName:this.buttonName4,buttonManualCode:this.buttonManualCode4});
                    }else{
                        arr.push({menuButtonCode:newGuid(),buttonName:this.buttonName4,buttonManualCode:this.buttonManualCode4});
                    }
                }
                if(this.buttonName5 != '' && this.buttonMenualCode5 != ''){
                    if(this.listMenuButton[4]!=null){
                        arr.push({menuButtonCode:this.listMenuButton[4].menuButtonCode,buttonName:this.buttonName5,buttonManualCode:this.buttonManualCode5});
                    }else{
                        arr.push({menuButtonCode:newGuid(),buttonName:this.buttonName5,buttonManualCode:this.buttonManualCode5});
                    }
                }
                if(this.buttonName6 != '' && this.buttonMenualCode6 != ''){
                    if(this.listMenuButton[5]!=null){
                        arr.push({menuButtonCode:this.listMenuButton[5].menuButtonCode,buttonName:this.buttonName6,buttonManualCode:this.buttonManualCode6});
                    }else{
                        arr.push({menuButtonCode:newGuid(),buttonName:this.buttonName6,buttonManualCode:this.buttonManualCode6});
                    }
                }


                if(arr.length ==0){
                    //return;
                }

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Menu/EditMenuButton",
                    data: {
                        timeStr:timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                        menuCode:this.menuCode,
                        listMenuButton:arr,
                    }
                }).then(
                    (response) => {
                        console.log(response);
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEditButton");
                            this.$emit("menuShow");
                        } else {
                            this.$message({type: 'info', message: '编辑失败'});
                        }

                    }
                )


            },



        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x: auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }

            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: scroll;
                height: auto;
            }

            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left: 16px;
        width: 56px;
        height: 36px;
        border: none;
        cursor: pointer;
    }

    .btn-close {
        color: #313131;
        background-color: transparent;
    }


    .row {
        padding: 10px 0px;
    }

    .item {
        padding: 5px 20px;
    }

    .label {
        padding: 5px 0px;
    }


</style>
